import { Grid, useMediaQuery } from "@mui/material";
import { ArrayField, Datagrid, FunctionField, Labeled, TextField, useRecordContext } from "react-admin";

import { settings } from "app";
import DocumentFileLink from "components/Erasmus/Partials/DocumentFileLink";
import { SectionTitle } from "features/SectionTitle";

const DOCUMENT_FIELDS = [
  { source: "cvDocumentId", label: "CV" },
  { source: "motivationLetterDocumentId", label: "Мотивационно писмо" },
  { source: "bankAccountCertificateDocumentId", label: "Удостоверение за банкова сметка" },
  { source: "recommendationDocumentId", label: "Препоръка" },
  { source: "languageCertificateDocumentId", label: "Езиков сертификат" },
];

const DocumentsSection = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  const record = useRecordContext();

  if (!record) return null;

  return (
    <>
      <SectionTitle
        paddingY={2}
        title="Документи"
        textAlign="center"
      />
      <Grid
        container
        spacing={2}
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        {DOCUMENT_FIELDS.map(({ source, label }) =>
          record[source] ? (
            <Grid
              key={source}
              item
              xs={12}
              md={4}
            >
              <Labeled label={label}>
                <DocumentFileLink
                  id={record[source]}
                  documentName={label}
                />
              </Labeled>
            </Grid>
          ) : null,
        )}

        {record.additionalCertificates?.length > 0 ? (
          <Grid
            item
            xs={12}
          >
            <Labeled label="Допълнителни сертификати">
              <ArrayField
                source="additionalCertificates"
                label="Допълнителни сертификати"
              >
                <Datagrid
                  bulkActionButtons={false}
                  size="small"
                  rowClick={false}
                  sx={settings.style.detailsDatagrid}
                >
                  <TextField
                    source="name"
                    label="Име"
                    sortable={false}
                    emptyText="-"
                  />
                  <FunctionField
                    label="Документ"
                    render={certificate => (
                      <DocumentFileLink
                        id={certificate.documentId}
                        documentName={certificate.name || "сертификат"}
                      />
                    )}
                  />
                </Datagrid>
              </ArrayField>
            </Labeled>
          </Grid>
        ) : null}
      </Grid>
    </>
  );
};

export default DocumentsSection;
